import { render, staticRenderFns } from "./RecycleScroller.vue?vue&type=template&id=806334bc"
import script from "./RecycleScroller.vue?vue&type=script&lang=js"
export * from "./RecycleScroller.vue?vue&type=script&lang=js"
import style0 from "./RecycleScroller.vue?vue&type=style&index=0&id=806334bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports